import { createFileRoute } from "@tanstack/react-router";
import { Eingang } from "../features/shell/Eingang";

export const Route = createFileRoute("/eingang")({
  component: Eingang,
});
